import { lotFunFacts, type LotFactInput } from '@auctisync/api-client';

/**
 * Module #23 chunk 5 — derived "fun facts" about a lot that surface activity.
 *
 * ⚠️ WHICH facts apply, and their wording, live in `@auctisync/api-client`'s
 * `lotFunFacts` — NOT here. They used to be derived inline in this file, which
 * meant the native app had to either re-implement the same thresholds or go
 * without. It went without. Now both surfaces call the same function and this
 * component owns only the presentation. See the no-mechanical-divergence rule
 * in CLAUDE.md.
 */
export function LotFunFacts(props: LotFactInput) {
  const facts = lotFunFacts(props);
  if (facts.length === 0) return null;

  return (
    <div
      style={{
        marginTop: '0.75rem',
        padding: '0.65rem 0.85rem',
        background: 'var(--surface-muted)',
        borderRadius: '0.5rem',
        fontSize: '0.85rem',
        color: 'var(--text-muted)',
        display: 'flex',
        gap: '1rem',
        flexWrap: 'wrap',
      }}
    >
      {facts.map((fact, i) => (
        <span key={fact}>
          {i > 0 ? <span style={{ marginRight: '1rem' }}>·</span> : null}
          {fact}
        </span>
      ))}
    </div>
  );
}
